module.exports = {
  email: 'thesufyansattar@gmail.com',

  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/thesufyansattar',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/thesufyansattar',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/thesufyansattar',
    },
    {
      name: 'Facebook',
      url: 'https://facebook.com/thesufyansattar',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/thesufyansattar',
    },
  ],

  navLinks: [
    { name: 'Home', url: '/' },
    { name: 'Experience', url: '/experience' },
    { name: 'Projects', url: '/projects' },
    // { name: 'Services', url: '/services' },
    { name: 'Pensieve', url: '/pensieve' },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
